var map = {
	"./audio/mute.svg": 515,
	"./audio/mute_blue.svg": 261,
	"./audio/mute_red.svg": 117,
	"./audio/mute_sky.svg": 214,
	"./audio/mute_white.svg": 215,
	"./audio/volume.svg": 516,
	"./audio/volume_blue.svg": 262,
	"./audio/volume_red.svg": 118,
	"./audio/volume_sky.svg": 216,
	"./audio/volume_white.svg": 217,
	"./banner/ball-backgroud.png": 263,
	"./banner/banner_lotto5.svg": 264,
	"./banner/lottery5_banner.png": 265,
	"./banner/lottery5_banner_MHSB999.png": 266,
	"./banner/lottery5_banner_MHSBGREEN.png": 267,
	"./data-found.gif": 268,
	"./flags/cambodia-round.svg": 248,
	"./flags/cambodia.svg": 165,
	"./flags/chinese.svg": 167,
	"./flags/singapore.svg": 517,
	"./flags/thailand.svg": 168,
	"./flags/united-state.svg": 166,
	"./flags/vietname.svg": 169,
	"./home/Lotto12.jpg": 269,
	"./home/Lotto12.png": 518,
	"./home/Lotto5.jpg": 270,
	"./home/Lotto5.png": 519,
	"./home/Lotto6.jpg": 271,
	"./home/Lotto6.png": 520,
	"./home/Lotto90.jpg": 272,
	"./home/Lotto99.png": 273,
	"./home/call_center.png": 521,
	"./home/line-footer.png": 522,
	"./home/lo12.png": 274,
	"./home/lo12v2.png": 275,
	"./home/lo5.png": 276,
	"./home/lo5d.png": 277,
	"./home/lo6.png": 278,
	"./home/lo90.png": 279,
	"./icons/5d.svg": 523,
	"./icons/about-us.svg": 524,
	"./icons/clock.svg": 525,
	"./icons/home.svg": 526,
	"./icons/how-to-play.svg": 527,
	"./icons/mute.svg": 528,
	"./icons/next.svg": 529,
	"./icons/result.svg": 530,
	"./icons/ticket-white.svg": 531,
	"./icons/ticket.svg": 532,
	"./icons/volume.svg": 533,
	"./jackpot/1": 280,
	"./jackpot/1.gif": 534,
	"./jackpot/1.json": 280,
	"./jackpot/2": 281,
	"./jackpot/2.gif": 535,
	"./jackpot/2.json": 281,
	"./jackpot/2.png": 282,
	"./jackpot/3": 283,
	"./jackpot/3.gif": 536,
	"./jackpot/3.json": 283,
	"./jackpot/3.png": 284,
	"./jackpot/4": 285,
	"./jackpot/4.gif": 537,
	"./jackpot/4.json": 285,
	"./jackpot/4.png": 286,
	"./jackpot/5": 287,
	"./jackpot/5.gif": 538,
	"./jackpot/5.json": 287,
	"./jackpot/5.png": 288,
	"./jackpot/loading": 289,
	"./jackpot/loading.json": 289,
	"./jackpot/show/10.gif": 539,
	"./jackpot/show/15.gif": 540,
	"./jackpot/show/2.gif": 541,
	"./jackpot/show/3.gif": 542,
	"./jackpot/show/4.gif": 543,
	"./jackpot/show/5.gif": 544,
	"./jackpot/v2/2.png": 171,
	"./jackpot/v2/3.png": 172,
	"./jackpot/v2/4.png": 173,
	"./jackpot/v2/5.png": 174,
	"./jackpot/v2/border-jackpot.png": 90,
	"./keno/Loading_Linear.gif": 290,
	"./keno/bg.png": 545,
	"./lo5d/lotto5d_bg.png": 546,
	"./lo5d/post/lo5d_post_A.png": 547,
	"./lo5d/post/lo5d_post_A.svg": 291,
	"./lo5d/post/lo5d_post_B.png": 548,
	"./lo5d/post/lo5d_post_B.svg": 292,
	"./lo5d/post/lo5d_post_C.png": 549,
	"./lo5d/post/lo5d_post_C.svg": 293,
	"./lo5d/post/lo5d_post_D.png": 550,
	"./lo5d/post/lo5d_post_D.svg": 294,
	"./lo5d/result/0.svg": 551,
	"./lo5d/result/1.svg": 552,
	"./lo5d/result/2.svg": 553,
	"./lo5d/result/3.svg": 554,
	"./lo5d/result/4.svg": 555,
	"./lo5d/result/5.svg": 556,
	"./lo5d/result/6.svg": 557,
	"./lo5d/result/7.svg": 558,
	"./lo5d/result/8.svg": 559,
	"./lo5d/result/9.svg": 560,
	"./logo/BCT168.png": 138,
	"./logo/KPW.png": 175,
	"./logo/LMHSB168.png": 176,
	"./logo/MHSB168.png": 177,
	"./logo/MHSB999.png": 295,
	"./logo/MHSBC.png": 296,
	"./logo/MHSBGREEN.png": 297,
	"./logo/MHSBKP.png": 298,
	"./logo/MT168.png": 299,
	"./logo/P99.png": 300,
	"./logo/SBS636.png": 301,
	"./logo/facebook.svg": 178,
	"./logo/fullscreen.svg": 179,
	"./logo/logo-en.png": 180,
	"./logo/logo2.png": 302,
	"./logo/youtube.svg": 181,
	"./lotto12/888": 182,
	"./lotto12/888.json": 182,
	"./lotto12/888.png": 303,
	"./lotto12/BCT168": 183,
	"./lotto12/BCT168.json": 183,
	"./lotto12/BCT168.png": 304,
	"./lotto12/KPW": 184,
	"./lotto12/KPW.json": 184,
	"./lotto12/KPW.png": 305,
	"./lotto12/LMHSB168": 185,
	"./lotto12/LMHSB168.json": 185,
	"./lotto12/LMHSB168.png": 306,
	"./lotto12/MHSB168": 186,
	"./lotto12/MHSB168.json": 186,
	"./lotto12/MHSB168.png": 307,
	"./lotto12/MHSB999": 187,
	"./lotto12/MHSB999.json": 187,
	"./lotto12/MHSB999.png": 308,
	"./lotto12/MHSBC": 188,
	"./lotto12/MHSBC.json": 188,
	"./lotto12/MHSBC.png": 309,
	"./lotto12/MHSBGREEN": 189,
	"./lotto12/MHSBGREEN.json": 189,
	"./lotto12/MHSBGREEN.png": 310,
	"./lotto12/P99": 190,
	"./lotto12/P99.json": 190,
	"./lotto12/P99.png": 311,
	"./lotto12/SBS636": 191,
	"./lotto12/SBS636.json": 191,
	"./lotto12/SBS636.png": 312,
	"./lotto12/cards/no-price/kp/EIGHT.png": 313,
	"./lotto12/cards/no-price/kp/ELEVEN.png": 314,
	"./lotto12/cards/no-price/kp/FIVE.png": 315,
	"./lotto12/cards/no-price/kp/FOUR.png": 316,
	"./lotto12/cards/no-price/kp/NINE.png": 317,
	"./lotto12/cards/no-price/kp/ONE.png": 318,
	"./lotto12/cards/no-price/kp/SEVEN.png": 319,
	"./lotto12/cards/no-price/kp/SIX.png": 320,
	"./lotto12/cards/no-price/kp/TEN.png": 321,
	"./lotto12/cards/no-price/kp/THREE.png": 322,
	"./lotto12/cards/no-price/kp/TWELVE.png": 323,
	"./lotto12/cards/no-price/kp/TWO.png": 324,
	"./lotto12/cards/no-price/normal/v1/EIGHT.png": 325,
	"./lotto12/cards/no-price/normal/v1/ELEVEN.png": 326,
	"./lotto12/cards/no-price/normal/v1/FIVE.png": 327,
	"./lotto12/cards/no-price/normal/v1/FOUR.png": 328,
	"./lotto12/cards/no-price/normal/v1/NINE.png": 329,
	"./lotto12/cards/no-price/normal/v1/ONE.png": 330,
	"./lotto12/cards/no-price/normal/v1/SEVEN.png": 331,
	"./lotto12/cards/no-price/normal/v1/SIX.png": 332,
	"./lotto12/cards/no-price/normal/v1/TEN.png": 333,
	"./lotto12/cards/no-price/normal/v1/THREE.png": 334,
	"./lotto12/cards/no-price/normal/v1/TWELVE.png": 335,
	"./lotto12/cards/no-price/normal/v1/TWO.png": 336,
	"./lotto12/cards/no-price/normal/v2/EIGHT.png": 337,
	"./lotto12/cards/no-price/normal/v2/ELEVEN.png": 338,
	"./lotto12/cards/no-price/normal/v2/FIVE.png": 339,
	"./lotto12/cards/no-price/normal/v2/FOUR.png": 340,
	"./lotto12/cards/no-price/normal/v2/NINE.png": 341,
	"./lotto12/cards/no-price/normal/v2/ONE.png": 342,
	"./lotto12/cards/no-price/normal/v2/SEVEN.png": 343,
	"./lotto12/cards/no-price/normal/v2/SIX.png": 344,
	"./lotto12/cards/no-price/normal/v2/TEN.png": 345,
	"./lotto12/cards/no-price/normal/v2/THREE.png": 346,
	"./lotto12/cards/no-price/normal/v2/TWELVE.png": 347,
	"./lotto12/cards/no-price/normal/v2/TWO.png": 348,
	"./lotto12/cards/no-price/normal/v3/EIGHT.png": 349,
	"./lotto12/cards/no-price/normal/v3/ELEVEN.png": 350,
	"./lotto12/cards/no-price/normal/v3/FIVE.png": 351,
	"./lotto12/cards/no-price/normal/v3/FOUR.png": 352,
	"./lotto12/cards/no-price/normal/v3/NINE.png": 353,
	"./lotto12/cards/no-price/normal/v3/ONE.png": 354,
	"./lotto12/cards/no-price/normal/v3/SEVEN.png": 355,
	"./lotto12/cards/no-price/normal/v3/SIX.png": 356,
	"./lotto12/cards/no-price/normal/v3/TEN.png": 357,
	"./lotto12/cards/no-price/normal/v3/THREE.png": 358,
	"./lotto12/cards/no-price/normal/v3/TWELVE.png": 359,
	"./lotto12/cards/no-price/normal/v3/TWO.png": 360,
	"./lotto12/slots/BLUE.png": 361,
	"./lotto12/slots/GREEN.png": 362,
	"./lotto12/slots/ODD.png": 363,
	"./lotto12/slots/OVER.png": 364,
	"./lotto12/slots/UNDER.png": 365,
	"./lotto12/slots/no-price/BLUE.png": 366,
	"./lotto12/slots/no-price/EVEN.png": 367,
	"./lotto12/slots/no-price/GREEN.png": 368,
	"./lotto12/slots/no-price/ODD.png": 369,
	"./lotto12/slots/no-price/OVER.png": 370,
	"./lotto12/slots/no-price/RED.png": 371,
	"./lotto12/slots/no-price/UNDER.png": 372,
	"./lotto12v2/bg-light-1.png": 561,
	"./lotto12v2/bg-light-2.png": 562,
	"./lotto12v2/cards/1.png": 563,
	"./lotto12v2/cards/10.png": 564,
	"./lotto12v2/cards/11.png": 565,
	"./lotto12v2/cards/12.png": 566,
	"./lotto12v2/cards/2.png": 567,
	"./lotto12v2/cards/3.png": 568,
	"./lotto12v2/cards/4.png": 569,
	"./lotto12v2/cards/5.png": 570,
	"./lotto12v2/cards/6.png": 571,
	"./lotto12v2/cards/7.png": 572,
	"./lotto12v2/cards/8.png": 573,
	"./lotto12v2/cards/9.png": 574,
	"./lotto12v2/cards/active/1.png": 575,
	"./lotto12v2/cards/active/10.png": 576,
	"./lotto12v2/cards/active/11.png": 577,
	"./lotto12v2/cards/active/12.png": 578,
	"./lotto12v2/cards/active/2.png": 579,
	"./lotto12v2/cards/active/3.png": 580,
	"./lotto12v2/cards/active/4.png": 581,
	"./lotto12v2/cards/active/5.png": 582,
	"./lotto12v2/cards/active/6.png": 583,
	"./lotto12v2/cards/active/7.png": 584,
	"./lotto12v2/cards/active/8.png": 585,
	"./lotto12v2/cards/active/9.png": 586,
	"./lotto12v2/exit_fullscreen.png": 587,
	"./lotto12v2/fullscreen.png": 588,
	"./lotto12v2/signs/1.png": 589,
	"./lotto12v2/signs/10.png": 590,
	"./lotto12v2/signs/11.png": 591,
	"./lotto12v2/signs/12.png": 592,
	"./lotto12v2/signs/2.png": 593,
	"./lotto12v2/signs/3.png": 594,
	"./lotto12v2/signs/4.png": 595,
	"./lotto12v2/signs/5.png": 596,
	"./lotto12v2/signs/6.png": 597,
	"./lotto12v2/signs/7.png": 598,
	"./lotto12v2/signs/8.png": 599,
	"./lotto12v2/signs/9.png": 600,
	"./lotto12v2/zodiac_bg@1x.a104956b.png": 120,
	"./lotto12v2/zodiac_border.png": 218,
	"./lotto12v2/zodiac_left_bg.png": 219,
	"./lotto12v3/arrow.png": 220,
	"./lotto12v3/logo-arrow.png": 601,
	"./lotto12v3/lucky-wheel-img-0.png": 602,
	"./lotto12v3/lucky-wheel-img-1.png": 603,
	"./lotto12v3/lucky-wheel-img-10.png": 604,
	"./lotto12v3/lucky-wheel-img-11.png": 605,
	"./lotto12v3/lucky-wheel-img-12.png": 606,
	"./lotto12v3/lucky-wheel-img-2.png": 607,
	"./lotto12v3/lucky-wheel-img-3.png": 608,
	"./lotto12v3/lucky-wheel-img-4.png": 609,
	"./lotto12v3/lucky-wheel-img-5.png": 610,
	"./lotto12v3/lucky-wheel-img-6.png": 611,
	"./lotto12v3/lucky-wheel-img-7.png": 612,
	"./lotto12v3/lucky-wheel-img-8.png": 613,
	"./lotto12v3/lucky-wheel-img-9.png": 614,
	"./lotto12v3/lucky_border1.png": 615,
	"./lotto12v3/lucky_border2.png": 616,
	"./lotto12v3/zodiac_border.png": 151,
	"./lotto5/Loading999.gif": 373,
	"./lotto5/Loading_Linear.gif": 374,
	"./lotto5/banner.svg": 617,
	"./lotto5/logo-999.png": 618,
	"./lotto5/logo-kpw.png": 619,
	"./lotto5/logo.png": 375,
	"./lotto5/logo_white.png": 620,
	"./lotto90/logo.png": 376,
	"./lotto90/lotto90_drawing_bg.png": 221,
	"./lotto90/lotto90_v1_bg.png": 222,
	"./lotto99/bg-circle.png": 621,
	"./lotto99/bg-white-circle.png": 622,
	"./lotto99/bg99select1.png": 223,
	"./lotto99/checked-box.png": 623,
	"./lotto99/checked-post.png": 624,
	"./lotto99/code_number_bg.png": 625,
	"./lotto99/deng1.png": 626,
	"./lotto99/deng2.png": 627,
	"./lotto99/download (3).png": 628,
	"./lotto99/download.png": 629,
	"./lotto99/groups_bg.png": 224,
	"./lotto99/logo.png": 630,
	"./lotto99/mark99_logo.png": 631,
	"./lotto99/num99_bg.png": 632,
	"./lotto99/uncheck-box.png": 633,
	"./printer.svg": 634,
	"./refresh-circle.svg": 377,
	"./refresh-white.svg": 378,
	"./refresh.svg": 379,
	"./results/BLUE.png": 635,
	"./results/EVEN.png": 636,
	"./results/GREEN.png": 637,
	"./results/ODD.png": 638,
	"./results/OVER.png": 639,
	"./results/RED.png": 640,
	"./results/UNDER.png": 641,
	"./user/default.jpg": 642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 514;